var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { completedPage, submittedInvalidMfaToken, submittedMfaToken, submittedValidMfaToken, } from "../../../lib/Avo";
import Button from "../../../components/connect-ui/Button";
import { FullWidthForm } from "../../../components/Styles/Styles";
import { PAGES } from "../../../lib/TrellisAnalytics";
import TextField from "../../../components/connect-ui/TextField";
import { enteredUnlinkedApplication } from "../../unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import useEventPublisher from "../../../hooks/useEventPublisher";
import { useLocation } from "react-router-dom";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
import usePageEvent from "../../../hooks/usePageEvent";
import { usePostMFATokenMutation } from "../../../services/connect";
import useUnlinkedApplicationEntryRoute from "../../unlinked-application/useUnlinkedApplicationEntryRoute";
export function MFAInput(_a) {
    var failed = _a.failed, inProgress = _a.inProgress, selectedIssuer = _a.selectedIssuer, setMFAState = _a.setMFAState, connectionId = _a.connectionId;
    var page = usePageEvent();
    var _b = React.useState(""), mfaToken = _b[0], setMfaToken = _b[1];
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var eventPublisher = useEventPublisher();
    var location = useLocation();
    var postMFAToken = usePostMFATokenMutation({
        fixedCacheKey: location.pathname,
    })[0];
    var unlinkedEntryRoute = useUnlinkedApplicationEntryRoute();
    var push = useMemoryHistory().push;
    var dispatch = useAppDispatch();
    function handleTokenChange(_a) {
        var target = _a.target;
        setMfaToken(target.value);
    }
    function handleFail() {
        submittedInvalidMfaToken(commonAnalyticsProperties);
        setMFAState({ failed: true, inProgress: false });
    }
    function handleSubmit(event) {
        event.preventDefault();
        submittedMfaToken(commonAnalyticsProperties);
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: event.currentTarget.textContent, optionSelected: event.currentTarget.textContent }));
        eventPublisher.submitMFA();
        setMFAState({ failed: false, inProgress: true });
        postMFAToken({ id: connectionId, mfaToken: mfaToken })
            .unwrap()
            .then(function (_a) {
            var result = _a.result;
            if (result) {
                submittedValidMfaToken(commonAnalyticsProperties);
            }
            else {
                handleFail();
            }
        })
            .catch(function () {
            handleFail();
        });
    }
    React.useEffect(function () {
        page(PAGES.MFATOKEN);
    }, [page]);
    return (React.createElement(FullWidthForm, { onSubmit: handleSubmit },
        selectedIssuer ? (React.createElement("div", { className: "mb-3 flex text-sm leading-normal" },
            React.createElement("p", null,
                "Please input the one time passcode you received from",
                " ",
                selectedIssuer.name))) : null,
        React.createElement("div", { className: "mb-4 w-full" },
            React.createElement(TextField, { id: "mfaToken", name: "mfaToken", type: "text", className: "mfaToken", onChange: handleTokenChange, label: "MFA Token", value: mfaToken, required: true }),
            failed ? (React.createElement("div", { className: "mt-2 flex text-xs leading-normal text-red" },
                React.createElement("p", null, "Invalid Code, please try again."))) : null),
        React.createElement(Button, { type: "submit", disabled: inProgress }, inProgress ? "Validating..." : "Submit"),
        React.createElement("button", { className: "mt-5 text-trellis-black underline", onClick: function (ev) {
                completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                dispatch(enteredUnlinkedApplication("manual-forms"));
                push(unlinkedEntryRoute);
            } }, "Fill out forms manually")));
}
